// HELPERS
import { stringifyFptiProps } from '@/utils'

// CONSTANTS
import { commonModularProfileFptiProperties } from '@/constants'

export const EDIT_BIZ_INFO_PAGE_SHOWN_FPTI = {
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_info_page_shown',
}

export const EDIT_BIZ_INFO_BACK_LINK_CLICK_FPTI = stringifyFptiProps({
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_info_page_back_click',
})

export const EDIT_BIZ_INFO_PREVIEW_BUTTON_CLICK_FPTI = stringifyFptiProps({
  ...commonModularProfileFptiProperties,
  eventName: 'bp_business_info_page_preview_click',
})
